import React, {useState, useEffect} from "react"
import puzzleAnswerData from "../puzzleAnswerData"

function Switches(props) {
    const [switchValues, setSwitchValues] = useState({
        switchOne: 0,
        switchTwo: 0,
        switchThree: 0,
        switchFour: 0,
        switchFive: 0,
        switchSix: 0,
        switchSeven: 0,
        switchEight: 0,
        switchNine: 0,
        switchTen: 0
    })
    const [switchCode] = useState(puzzleAnswerData[5].switchCode)
    const switchData = [
        {
            id: 1,
            valueId: switchValues.switchOne,
            name: "switchOne"
        },
        {
            id: 2,
            valueId: switchValues.switchTwo,
            name: "switchTwo"
        },
        {
            id: 3,
            valueId: switchValues.switchThree,
            name: "switchThree"
        },
        {
            id: 4,
            valueId: switchValues.switchFour,
            name: "switchFour"
        },
        {
            id: 5,
            valueId: switchValues.switchFive,
            name: "switchFive"
        },
        {
            id: 6,
            valueId: switchValues.switchSix,
            name: "switchSix"
        },
        {
            id: 7,
            valueId: switchValues.switchSeven,
            name: "switchSeven"
        },
        {
            id: 8,
            valueId: switchValues.switchEight,
            name: "switchEight"
        },
        {
            id: 9,
            valueId: switchValues.switchNine,
            name: "switchNine"
        },
        {
            id: 10,
            valueId: switchValues.switchTen,
            name: "switchTen"
        }
    ]
    
    function handleChange(event) {
        const {value, id} = event.target
        setSwitchValues({
            ...switchValues,
            [id]: value
        })
    }
    
    useEffect(() => {
        const switchInput = String(switchValues.switchOne) + String(switchValues.switchTwo) + String(switchValues.switchThree) + String(switchValues.switchFour) + String(switchValues.switchFive) + String(switchValues.switchSix) + String(switchValues.switchSeven) + String(switchValues.switchEight) + String(switchValues.switchNine) + String(switchValues.switchTen)
        
        if (switchInput === switchCode) { setTimeout(() => completePuzzle(), 250) }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [switchValues, switchCode])
        
    
    function completePuzzle() {
            const show = "on"
            const text = "The door creaks open. On top of an old wooden table, sits a leather briefcase."
            const trigger = "switch"
            const complete = true
            props.callBackOverlay(show, text, trigger)
            props.callBackStatus(trigger, complete)
            props.callBackRevealClues("The Briefcase", "The Switches")
    }
    
    const switchImage = switchData.map(item => {
        return <div key={item.id} className="switch"></div> 
    })
    
    const switches = switchData.map(item => {
            return <input key={item.id} type="range" min="0" max="1" value={item.valueId} className="deskSwitches" id={item.name} onChange={handleChange} />
    })
    
    return (
        <div>
            <div className="doorFrame">                        
                <div className="doorHandle"></div>
                <div className="switchPanel">
                    {switchImage}
                </div>
            </div>

            <h3>There is no keyhole on this door and yet it is locked. Maybe these strange switches are the key.</h3>

            <div className="imageTextWrapper switchBoxWrapper">
                <div className="switchContainer">
                    {switches}
                </div>
            </div>
        </div>
    )
}

export default Switches